export const ADMINISTRATION_DASHBOARD: string = 'dashboard';
export const ADMINISTRATION_CHANNELING: string = 'channeling';
export const ADMINISTRATION_CHANNELING_GROUPS: string = 'groups';
export const ADMINISTRATION_CHANNELING_RULES: string = 'rules';
